import { useFlags } from 'config/useFlagsContext'
import { useSistemasExternosMenuLateralQuery } from 'graphql/hooks.generated'
import { useMemo } from 'react'

import { SistemaExterno } from './components/useLinkSistemaExterno'

export function useSistemasExternosMenuLateral() {
  const { PILOTO_SISTEMAS_EXTERNOS_ENABLED } = useFlags()

  const { data, loading } = useSistemasExternosMenuLateralQuery({
    skip: !PILOTO_SISTEMAS_EXTERNOS_ENABLED,
  })

  const sistemasExternos = useMemo<SistemaExterno[]>(() => {
    if (!data?.iframes) return []
    return data.iframes.map((iframe) => ({
      id: iframe.id,
      providerId: iframe.providerId,
      nome: iframe.nome,
    }))
  }, [data?.iframes])

  return { sistemasExternos, loading }
}
